module.exports = __webpack_public_path__ + "static/media/1.2222e6bb.png";